import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LocalStoreService {

  private ls = window.localStorage;

  filterPretrage = 'filterPretrage';
  pageSize = 'pageSize';
  pageNumber = 'pageNumber';
  sortBy = 'sortBy';
  direction = 'direction';
  kompanijaId = 'KompanijaId';
  jeMatura = 'jeMatura';
  pageSizeAdministracija = 'pageSizeAdministracija';
  pageNumberAdministracija = 'pageNumberAdministracija';
  filterPretrageBazaZadataka = 'filterPretrageBazaZadataka'
  pageSizeBazaZadataka = 'pageSizeBazaZadataka';
  pageNumberBazaZadataka = 'pageNumberBazaZadataka';

  pageSizeSkeningCentri = 'pageSizeSkeningCentri';
  pageNumberSkeningCentri = 'pageNumberSkeningCentri';

  pageSizeSkeneri = 'pageSizeSkeneri';
  pageNumberSkeneri = 'pageNumberSkeneri';

  idTesta = 'idTesta';

  constructor() { }

  public setItem(key: string, value) {
    value = JSON.stringify(value)
    this.ls.setItem(key, value)
    return true
  }

  public getItem(key: string) {
    let value = this.ls.getItem(key)
    try {
      return JSON.parse(value)
    } catch (e) {
      return null
    }
  }

  public removeItem(key: string) {
    this.ls.removeItem(key);
  }

  public clear() {
    this.ls.clear();
  }
}